export const environment = {
api: 'https://api.virtux.com.br/v1/',
//  api: 'http://localhost/v1/v1/',
  session: 'up.mobile',
  sessionCart: 'up.mobile.cart',
  production: true
};
